var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFireIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "fxemoji:fire"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10.4258 19.5483C3.83452 19.5483 2.07343 12.6773 2.86948 8.17541C2.90413 7.97948 3.16096 7.92303 3.27288 8.08756C3.61944 8.59694 3.92784 9.33268 4.43881 9.26881C5.20682 9.1728 5.73889 2.39592 10.2906 0.489089C10.4351 0.428581 10.5862 0.543386 10.5704 0.699167C10.3453 2.90749 11.6712 6.06901 14.0202 6.06901C15.3668 6.06901 16.2881 4.99432 16.7485 3.91503C16.8883 3.58717 17.3674 3.6285 17.4476 3.97581C18.2691 7.5337 20.4651 19.5483 10.4258 19.5483Z",
    fill: "#FF8F1F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M8.11362 12.923C8.26862 12.7928 8.50393 12.8821 8.53913 13.0815C8.62147 13.548 8.89225 14.3498 9.78045 14.3498C10.8489 14.3498 11.574 11.4098 11.7641 10.5451C11.7954 10.4029 11.934 10.3063 12.0768 10.3353C14.7469 10.8782 16.0451 19.5485 10.1743 19.5485C5.90041 19.5485 6.86866 13.9689 8.11362 12.923ZM15.4098 3.53342C15.5039 2.79741 14.1603 4.81049 14.1603 4.81049C14.1603 4.81049 15.1846 5.29432 15.4098 3.53342ZM1.8717 14.5101C1.90002 14.1967 1.49694 13.3578 1.42557 13.69C1.25475 14.4847 1.84338 14.8234 1.8717 14.5101Z",
    fill: "#FFB636"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M12.625 13.617C12.5249 13.1994 12.1658 14.1693 12.2109 14.5644C12.256 14.9594 12.8645 14.616 12.625 13.617Z",
    fill: "#FFD469"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFireIcon);
export default __webpack_public_path__ + "static/media/fireIcon.c20ecb2faae63295622079d173995663.svg";
export { ForwardRef as ReactComponent };